export type MediaType = 'movie' | 'tv' | 'variety';

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  heat: number;
  cover: string;
  banner: string;
  tagline: string;
  synopsis: string;
  director: string;
  cast: string[];
  duration: string;
  episodes: string;
  status: string;
  featured: boolean;
}

export const mediaList: MediaItem[] = [
  {
    id: 'm001',
    title: '星河迷航',
    type: 'movie',
    year: 2026,
    region: '中国大陆',
    genres: ['科幻', '冒险', '剧情'],
    rating: 9.1,
    heat: 9820,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20an%20epic%20sci-fi%20space%20film%2C%20lone%20astronaut%20before%20a%20giant%20glowing%20planet%2C%20deep%20blue%20and%20orange%20rim%20light%2C%20dramatic%20volumetric%20lighting%2C%20film%20grain%2C%20professional%20key%20art%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mock-cover-m001&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20space%20exploration%20film%2C%20a%20spaceship%20drifting%20toward%20a%20colossal%20ringed%20planet%2C%20deep%20navy%20nebula%20with%20warm%20orange%20sunlight%20edge%2C%20atmospheric%20volumetric%20glow%2C%20moody%20sci-fi%20key%20art%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=mock-banner-m001&orientation=landscape',
    tagline: '当人类第一次触碰星海的尽头',
    synopsis: '在不远的未来，一支由顶尖宇航员组成的深空远征队踏上了寻找第二家园的旅程。当飞船抵达一颗从未被记录的蓝色星球时，他们发现眼前的星海远比想象中更加深邃，也更加危险。一次关于勇气、信任与归途的星际冒险就此展开。',
    director: '苏景行',
    cast: ['林亦辰', '顾星河', '周慕白', '叶清欢'],
    duration: '142 分钟',
    episodes: '-',
    status: '已上映',
    featured: true,
  },
  {
    id: 'm002',
    title: '长安夜雨',
    type: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['古装', '悬疑', '剧情'],
    rating: 8.8,
    heat: 8640,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20for%20a%20Chinese%20historical%20mystery%20film%2C%20a%20lone%20figure%20in%20elegant%20traditional%20robe%20holding%20a%20lantern%20on%20a%20rainy%20night%20street%2C%20warm%20orange%20lantern%20light%20against%20deep%20navy%20darkness%2C%20reflective%20wet%20stones%2C%20cinematic%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=mock-cover-m002&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Atmospheric%20wide%20shot%20of%20an%20ancient%20Chinese%20city%20at%20night%20in%20the%20rain%2C%20glowing%20orange%20lanterns%20along%20a%20narrow%20lane%2C%20deep%20blue%20mist%20and%20old%20tile%20roofs%2C%20cinematic%20historical%20drama%20key%20art%2C%20volumetric%20light%2C%20no%20text&width=1600&height=900&seq=mock-banner-m002&orientation=landscape',
    tagline: '一桩旧案，半城风雨',
    synopsis: '一场连绵的夜雨揭开了长安城尘封十年的旧案。落魄的书生与执着的女捕快被迫联手，沿着蛛丝马迹穿行于繁华与阴暗之间，在层层反转里逼近真相，也逼近各自不敢面对的过去。',
    director: '程知远',
    cast: ['沈砚舟', '陆青禾', '秦未晚'],
    duration: '128 分钟',
    episodes: '-',
    status: '已上映',
    featured: true,
  },
  {
    id: 'm003',
    title: '无声告白',
    type: 'movie',
    year: 2025,
    region: '中国香港',
    genres: ['剧情', '家庭'],
    rating: 8.6,
    heat: 6120,
    cover: 'https://readdy.ai/api/search-image?query=Emotional%20movie%20poster%20for%20a%20quiet%20family%20drama%2C%20a%20parent%20and%20child%20sitting%20apart%20in%20soft%20window%20light%2C%20muted%20blue%20and%20warm%20cream%20tones%2C%20understated%20melancholy%20mood%2C%20minimalist%20composition%2C%20film%20key%20art%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mock-cover-m003&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Quiet%20cinematic%20interior%20scene%20of%20a%20family%20drama%2C%20sunlit%20room%20with%20sheer%20curtains%2C%20two%20silhouettes%20in%20gentle%20window%20light%2C%20muted%20blue%20and%20warm%20neutral%20palette%2C%20emotional%20and%20restrained%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-m003&orientation=landscape',
    tagline: '有些爱，从未说出口',
    synopsis: '一对父女在同一屋檐下生活了二十年，却始终隔着一堵沉默的墙。直到父亲病倒，女儿才在整理旧物时发现，那些被误解的岁月里藏着另一种表达方式。这是一部关于理解与和解的温柔之作。',
    director: '何静之',
    cast: ['张峻宁', '罗小满', '李承泽'],
    duration: '116 分钟',
    episodes: '-',
    status: '已上映',
    featured: false,
  },
  {
    id: 'm004',
    title: '城市之光',
    type: 'movie',
    year: 2024,
    region: '美国',
    genres: ['犯罪', '动作', '悬疑'],
    rating: 8.7,
    heat: 7930,
    cover: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20movie%20poster%2C%20a%20detective%20silhouette%20against%20a%20rain-soaked%20neon%20city%20skyline%20at%20night%2C%20deep%20navy%20shadows%20with%20warm%20orange%20street%20glow%2C%20tense%20noir%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=mock-cover-m004&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Moody%20wide%20shot%20of%20a%20night%20city%20for%20a%20crime%20thriller%2C%20rain%20slick%20streets%20reflecting%20amber%20lights%2C%20deep%20navy%20skyscrapers%20in%20fog%2C%20cinematic%20noir%20atmosphere%2C%20dramatic%20contrast%2C%20no%20text&width=1600&height=900&seq=mock-banner-m004&orientation=landscape',
    tagline: '黑暗之中，总有人提灯前行',
    synopsis: '一名被停职的警探为了洗清冤屈，独自潜入城市最阴暗的角落。随着线索层层展开，他发现真相比想象中更庞大。在霓虹与雨夜交织的都市里，正义与代价从来都难以两全。',
    director: 'Marcus Reed',
    cast: ['Ethan Cole', 'Nora Vance', 'Julian Fox'],
    duration: '134 分钟',
    episodes: '-',
    status: '已上映',
    featured: true,
  },
  {
    id: 'm005',
    title: '摇滚年代',
    type: 'movie',
    year: 2024,
    region: '英国',
    genres: ['音乐', '剧情', '青春'],
    rating: 8.4,
    heat: 5210,
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20music%20drama%20movie%20poster%2C%20a%20young%20guitarist%20on%20a%20stage%20under%20warm%20orange%20concert%20light%2C%20deep%20blue%20crowd%20silhouettes%2C%20sweat%20and%20motion%20energy%2C%20cinematic%20key%20art%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mock-cover-m005&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Live%20music%20concert%20wide%20shot%20for%20a%20rock%20band%20drama%2C%20silhouetted%20musicians%20on%20stage%20bathed%20in%20amber%20and%20deep%20blue%20stage%20light%2C%20hazy%20spotlight%20beams%2C%20crowd%20energy%2C%20cinematic%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-m005&orientation=landscape',
    tagline: '青春就是要震耳欲聋',
    synopsis: '四个来自小镇的年轻人因为一场地下演出走到一起，用一支乐队对抗平庸的生活。在梦想与现实的拉扯中，他们逐渐明白，真正值得坚持的不是舞台有多大，而是心里的那首歌从未停止。',
    director: 'Oliver Grant',
    cast: ['Leo Hart', 'Mia Bennett', 'Sam Doyle'],
    duration: '121 分钟',
    episodes: '-',
    status: '已上映',
    featured: false,
  },
  {
    id: 'm006',
    title: '雾林谜案',
    type: 'movie',
    year: 2023,
    region: '韩国',
    genres: ['悬疑', '惊悚', '犯罪'],
    rating: 8.5,
    heat: 6740,
    cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20thriller%20poster%2C%20a%20forest%20shrouded%20in%20dense%20fog%20with%20a%20single%20figure%20and%20lantern%2C%20cold%20deep%20blue%20mist%20with%20a%20small%20warm%20orange%20glow%2C%20eerie%20tense%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-m006&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Eerie%20wide%20shot%20of%20a%20foggy%20pine%20forest%20for%20a%20mystery%20thriller%2C%20layered%20deep%20blue%20mist%20between%20tall%20trees%2C%20a%20faint%20warm%20light%20in%20the%20distance%2C%20cinematic%20suspense%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-m006&orientation=landscape',
    tagline: '迷雾深处，谁在说谎',
    synopsis: '一场大雾封锁了整座山中小镇，也封住了一桩离奇的失踪案。被调来协助的女刑警发现，镇上的每个人都藏着不愿提及的秘密。随着雾气一次次聚散，真相在谎言中浮沉。',
    director: 'Park Ji-hoon',
    cast: ['Han Seo-yeon', 'Kim Min-jae', 'Lee Da-eun'],
    duration: '118 分钟',
    episodes: '-',
    status: '已上映',
    featured: false,
  },
  {
    id: 'm007',
    title: '夏日回声',
    type: 'movie',
    year: 2023,
    region: '日本',
    genres: ['剧情', '爱情', '治愈'],
    rating: 8.9,
    heat: 7100,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20coming%20of%20age%20movie%20poster%2C%20two%20teenagers%20on%20a%20seaside%20cliff%20in%20golden%20summer%20light%2C%20deep%20blue%20sea%20and%20warm%20orange%20sunset%20sky%2C%20bittersweet%20romantic%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-m007&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Beautiful%20wide%20summer%20seaside%20scene%20for%20a%20romantic%20drama%2C%20deep%20blue%20ocean%20waves%20under%20a%20warm%20orange%20sunset%2C%20distant%20silhouettes%20on%20a%20pier%2C%20nostalgic%20gentle%20atmosphere%2C%20cinematic%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-m007&orientation=landscape',
    tagline: '那个夏天，风里有我们的名字',
    synopsis: '海岛小镇的最后一个夏天，两个即将远行的少年少女约定，要在分别前完成一件未竟的心愿。海风、蝉鸣与未寄出的信，共同拼凑出一段清澈又遗憾的青春记忆。',
    director: 'Aoi Nakamura',
    cast: ['Sota Fujii', 'Yui Harada', 'Ren Kobayashi'],
    duration: '124 分钟',
    episodes: '-',
    status: '已上映',
    featured: true,
  },
  {
    id: 'm008',
    title: '铁血归途',
    type: 'movie',
    year: 2022,
    region: '中国大陆',
    genres: ['战争', '剧情', '历史'],
    rating: 8.3,
    heat: 5890,
    cover: 'https://readdy.ai/api/search-image?query=Historical%20war%20drama%20movie%20poster%2C%20a%20weathered%20soldier%20standing%20alone%20on%20a%20battlefield%20hill%2C%20deep%20navy%20storm%20clouds%20with%20a%20warm%20orange%20sunrise%20break%2C%20stoic%20epic%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-m008&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20historical%20battlefield%20wide%20shot%2C%20rows%20of%20soldiers%20in%20misty%20dawn%20light%2C%20deep%20blue%20and%20warm%20amber%20sky%2C%20distant%20mountains%2C%20cinematic%20war%20drama%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-m008&orientation=landscape',
    tagline: '走得再远，也要回家',
    synopsis: '战火散去多年后，一位老兵带着战友的遗愿踏上了跨越千里的归乡之路。沿途的风景与相遇的人，让他重新理解了牺牲、承诺与家国的分量。',
    director: '程知远',
    cast: ['沈砚舟', '王铁林', '孙秀兰'],
    duration: '136 分钟',
    episodes: '-',
    status: '已上映',
    featured: false,
  },
  {
    id: 't001',
    title: '琉璃岁月',
    type: 'tv',
    year: 2026,
    region: '中国大陆',
    genres: ['年代', '剧情', '家庭'],
    rating: 9.0,
    heat: 9450,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20series%20poster%2C%20an%20elegant%20woman%20in%20vintage%20republic-era%20dress%20by%20a%20rainy%20window%2C%20warm%20orange%20lamp%20light%20and%20deep%20blue%20shadows%2C%20nostalgic%20refined%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t001&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Nostalgic%20wide%20shot%20of%20a%20vintage%20Chinese%20town%20street%20at%20dusk%2C%20warm%20orange%20lamp%20glow%20against%20deep%20blue%20evening%2C%20period%20architecture%2C%20cinematic%20drama%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-t001&orientation=landscape',
    tagline: '三代人的光阴，一个家族的兴衰',
    synopsis: '故事围绕一座老宅与一个家族三代人的命运展开。从动荡年代到崭新时代，母子、夫妻、手足之间的情感在时代洪流中反复考验，也沉淀出历久弥新的温度。',
    director: '袁知秋',
    cast: ['黎晚晴', '陆承安', '周静娴'],
    duration: '-',
    episodes: '全 42 集',
    status: '已完结',
    featured: true,
  },
  {
    id: 't002',
    title: '潜行者',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['谍战', '悬疑', '动作'],
    rating: 8.9,
    heat: 8870,
    cover: 'https://readdy.ai/api/search-image?query=Spy%20thriller%20series%20poster%2C%20a%20man%20in%20a%20long%20coat%20and%20hat%20in%20a%20dim%20rainy%20alley%2C%20deep%20navy%20shadows%20with%20warm%20orange%20lamp%20glow%2C%20tense%20noir%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=mock-cover-t002&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Atmospheric%20wide%20shot%20of%20a%20mid-century%20city%20street%20at%20night%20for%20a%20spy%20thriller%2C%20rain%20and%20deep%20blue%20fog%2C%20warm%20orange%20streetlight%20pools%2C%20cinematic%20suspense%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-t002&orientation=landscape',
    tagline: '潜伏在黑暗里的人',
    synopsis: '一个代号「潜行者」的秘密身份，让主人公在敌我难辨的局势中步步惊心。每一次擦肩而过的接头、每一封真假难辨的情报，都可能决定生死。谍战与人性在暗夜中交锋。',
    director: '程知远',
    cast: ['霍远舟', '洛知夏', '雷振国'],
    duration: '-',
    episodes: '全 36 集',
    status: '已完结',
    featured: true,
  },
  {
    id: 't003',
    title: '山海拾遗',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['奇幻', '古装', '冒险'],
    rating: 8.7,
    heat: 8210,
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20series%20poster%2C%20a%20young%20traveler%20with%20a%20glowing%20ancient%20scroll%20on%20a%20mountain%20path%2C%20deep%20blue%20ethereal%20sky%20with%20warm%20orange%20magic%20light%2C%20mythical%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t003&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Grand%20mythical%20wide%20landscape%20for%20a%20fantasy%20series%2C%20floating%20islands%20over%20a%20misty%20sea%2C%20deep%20blue%20twilight%20with%20warm%20orange%20cloud%20glow%2C%20epic%20ancient%20atmosphere%2C%20cinematic%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-t003&orientation=landscape',
    tagline: '山河遗迹，藏着上古的秘密',
    synopsis: '少女意外得到一卷记载山海异兽的古老残书，从此踏上寻找失落遗迹的旅途。她与冷面剑客、贪吃的小妖组成临时小队，在一次次凶险中揭开上古传说背后的真相。',
    director: '叶澜舟',
    cast: ['宁清欢', '谢云归', '白小狸'],
    duration: '-',
    episodes: '更新至 28 集',
    status: '连载中',
    featured: false,
  },
  {
    id: 't004',
    title: '都市温度',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '爱情', '剧情'],
    rating: 8.4,
    heat: 7320,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20series%20poster%2C%20a%20young%20couple%20in%20a%20glass%20office%20lobby%20lit%20by%20warm%20evening%20light%2C%20deep%20blue%20city%20bokeh%20outside%2C%20warm%20orange%20tone%2C%20clean%20contemporary%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t004&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20blue%20hour%20for%20an%20urban%20romance%20series%2C%20glass%20towers%20with%20warm%20orange%20window%20lights%2C%20clean%20contemporary%20cinematic%20key%20art%2C%20soft%20gradient%20sky%2C%20no%20text&width=1600&height=900&seq=mock-banner-t004&orientation=landscape',
    tagline: '在钢筋森林里，遇见彼此的温柔',
    synopsis: '两个在原野上生活背景截然不同的年轻人，在快节奏的大城市里成为邻居。从误解到理解，从陌生到依赖，他们在柴米油盐与工作压力中，慢慢学会为对方留一盏灯。',
    director: '温子谦',
    cast: ['程一诺', '许知遥', '安然'],
    duration: '-',
    episodes: '全 32 集',
    status: '已完结',
    featured: false,
  },
  {
    id: 't005',
    title: '暗流',
    type: 'tv',
    year: 2024,
    region: '中国香港',
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.6,
    heat: 6980,
    cover: 'https://readdy.ai/api/search-image?query=Crime%20drama%20series%20poster%2C%20a%20stern%20detective%20before%20a%20harbor%20of%20dark%20water%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20orange%20port%20lights%2C%20tense%20serious%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t005&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Moody%20wide%20shot%20of%20a%20night%20harbor%20for%20a%20crime%20drama%2C%20dark%20deep%20blue%20water%20with%20warm%20orange%20container%20crane%20lights%2C%20cinematic%20suspense%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-t005&orientation=landscape',
    tagline: '水面之下，暗流涌动',
    synopsis: '一桩看似普通的走私案，牵扯出盘踞多年的地下网络。新上任的督察与老练的线人联手，在利益与情义之间艰难前行，誓要将藏在暗处的真相拉出水面。',
    director: 'Kenny Leung',
    cast: ['陈家豪', '卓文珊', '高天赐'],
    duration: '-',
    episodes: '全 30 集',
    status: '已完结',
    featured: false,
  },
  {
    id: 't006',
    title: '青春纪事',
    type: 'tv',
    year: 2023,
    region: '中国大陆',
    genres: ['青春', '校园', '成长'],
    rating: 8.5,
    heat: 6510,
    cover: 'https://readdy.ai/api/search-image?query=Bright%20youth%20campus%20series%20poster%2C%20a%20group%20of%20students%20in%20uniforms%20laughing%20on%20a%20schoolyard%20in%20golden%20afternoon%20light%2C%20deep%20blue%20sky%20and%20warm%20orange%20sun%2C%20cheerful%20nostalgic%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t006&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Sunny%20school%20campus%20wide%20shot%20in%20golden%20afternoon%20light%2C%20deep%20blue%20sky%20with%20warm%20orange%20sun%20glow%2C%20empty%20track%20and%20trees%2C%20nostalgic%20youth%20drama%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-t006&orientation=landscape',
    tagline: '那些年，我们一起长大的日子',
    synopsis: '六个性格迥异的高中生，在三年同窗时光里经历了友情、暗恋、争执与和解。黑板上的倒计时、操场上的黄昏与毕业照里的笑脸，串成一部属于所有人的青春纪事。',
    director: '温子谦',
    cast: ['安然', '夏一禾', '周予安'],
    duration: '-',
    episodes: '全 24 集',
    status: '已完结',
    featured: false,
  },
  {
    id: 't007',
    title: '破晓行动',
    type: 'tv',
    year: 2023,
    region: '美国',
    genres: ['动作', '惊悚', '谍战'],
    rating: 8.2,
    heat: 5720,
    cover: 'https://readdy.ai/api/search-image?query=Action%20thriller%20series%20poster%2C%20an%20agent%20silhouette%20against%20an%20explosive%20dawn%20skyline%2C%20deep%20navy%20and%20warm%20orange%20firelight%2C%20high%20tension%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=mock-cover-t007&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dramatic%20dawn%20city%20wide%20shot%20for%20an%20action%20thriller%20series%2C%20deep%20blue%20sky%20with%20warm%20orange%20horizon%20glow%2C%20silhouetted%20skyline%2C%20cinematic%20tension%2C%20no%20text&width=1600&height=900&seq=mock-banner-t007&orientation=landscape',
    tagline: '天亮之前，解决一切',
    synopsis: '一支精英行动小组接到了一项几乎不可能完成的任务——在天亮前潜入戒备森严的设施。随着计划接连失控，成员们必须在信任与背叛之间做出抉择。',
    director: 'Marcus Reed',
    cast: ['Ethan Cole', 'Ivy Shaw', 'Dan Mercer'],
    duration: '-',
    episodes: '全 18 集',
    status: '已完结',
    featured: false,
  },
  {
    id: 't008',
    title: '长安十二时',
    type: 'tv',
    year: 2022,
    region: '中国大陆',
    genres: ['古装', '悬疑', '权谋'],
    rating: 8.8,
    heat: 7640,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20series%20poster%2C%20a%20scholar%20in%20elegant%20robe%20holding%20a%20scroll%20before%20a%20grand%20palace%20wall%2C%20deep%20blue%20night%20with%20warm%20orange%20torchlight%2C%20epic%20ancient%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t008&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20palace%20at%20night%20wide%20shot%2C%20deep%20blue%20sky%20with%20warm%20orange%20torch%20glow%20along%20long%20corridors%2C%20epic%20historical%20drama%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-t008&orientation=landscape',
    tagline: '十二个时辰，一场惊天之局',
    synopsis: '长安城在一天之内接连发生异动，年轻的主簿与倔强的女官必须在十二个时辰内找出幕后黑手。权谋、智斗与人性在紧迫的时间线上层层展开，每一步都关乎满城安危。',
    director: '袁知秋',
    cast: ['陆承安', '苏挽月', '裴无咎'],
    duration: '-',
    episodes: '全 40 集',
    status: '已完结',
    featured: true,
  },
  {
    id: 'v001',
    title: '奇思妙想大会',
    type: 'variety',
    year: 2026,
    region: '中国大陆',
    genres: ['脱口秀', '喜剧', '竞技'],
    rating: 8.8,
    heat: 8920,
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20comedy%20variety%20show%20poster%2C%20colorful%20stage%20with%20a%20microphone%20and%20warm%20orange%20spotlight%2C%20deep%20blue%20audience%20silhouettes%2C%20playful%20energetic%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v001&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Energetic%20comedy%20variety%20show%20stage%20wide%20shot%2C%20deep%20blue%20backdrop%20with%20warm%20orange%20spotlights%2C%20glowing%20stage%20floor%2C%20fun%20entertaining%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-v001&orientation=landscape',
    tagline: '脑洞有多大，舞台就有多大',
    synopsis: '一群来自各行各业的「奇思妙想家」登上舞台，用五分钟的脑洞演讲挑战观众的想象力。从生活琐事到宇宙终极问题，笑声与思考在同一个夜晚轮番上演。',
    director: '综艺制作中心',
    cast: ['庞一鸣', '田小甜', '老徐', '阿May'],
    duration: '-',
    episodes: '更新至 10 期',
    status: '每周五更新',
    featured: true,
  },
  {
    id: 'v002',
    title: '环球食光',
    type: 'variety',
    year: 2025,
    region: '中国大陆',
    genres: ['美食', '旅行', '纪实'],
    rating: 9.0,
    heat: 9140,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20food%20travel%20variety%20show%20poster%2C%20a%20rustic%20table%20full%20of%20colorful%20dishes%20with%20steam%2C%20deep%20blue%20dusk%20background%20with%20warm%20orange%20lantern%20light%2C%20cozy%20appetizing%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v002&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Beautiful%20night%20market%20food%20street%20wide%20shot%2C%20steaming%20dishes%20and%20warm%20orange%20string%20lights%20under%20a%20deep%20blue%20evening%2C%20cozy%20travel%20documentary%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-v002&orientation=landscape',
    tagline: '用一顿饭，认识一座城',
    synopsis: '两位主持人背着行囊走遍世界的大小街巷，只为找到最地道的那一口。从清晨的市场到深夜的排档，食物背后的人情冷暖，才是这趟旅程真正的味道。',
    director: '纪录片工作室',
    cast: ['沈知味', '陆远行'],
    duration: '-',
    episodes: '更新至 14 期',
    status: '每周三更新',
    featured: true,
  },
  {
    id: 'v003',
    title: '这就是舞台',
    type: 'variety',
    year: 2025,
    region: '中国大陆',
    genres: ['音乐', '选秀', '竞技'],
    rating: 8.5,
    heat: 7780,
    cover: 'https://readdy.ai/api/search-image?query=Music%20talent%20show%20poster%2C%20a%20performer%20singing%20under%20a%20warm%20orange%20spotlight%20on%20a%20dark%20stage%2C%20deep%20blue%20haze%20and%20light%20beams%2C%20dramatic%20emotional%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v003&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dramatic%20music%20talent%20show%20stage%20wide%20shot%2C%20deep%20blue%20haze%20with%20warm%20orange%20spotlight%20beams%2C%20lone%20singer%20silhouette%2C%20cinematic%20stage%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-v003&orientation=landscape',
    tagline: '聚光灯下，梦想发光',
    synopsis: '来自全国各地的音乐追梦人同台竞技，用一首首歌曲讲述自己的故事。导师的犀利点评与选手的真诚表达交织，让每一次登台都成为值得被记住的瞬间。',
    director: '音乐综艺中心',
    cast: ['顾声', '苏念', '老周', '阿哲'],
    duration: '-',
    episodes: '更新至 8 期',
    status: '每週六更新',
    featured: false,
  },
  {
    id: 'v004',
    title: '奔跑吧少年',
    type: 'variety',
    year: 2024,
    region: '中国大陆',
    genres: ['竞技', '真人秀', '户外'],
    rating: 8.3,
    heat: 6890,
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20outdoor%20reality%20show%20poster%2C%20a%20group%20of%20young%20people%20running%20on%20a%20beach%20at%20sunset%2C%20deep%20blue%20sea%20with%20warm%20orange%20sun%2C%20playful%20competitive%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v004&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Energetic%20outdoor%20reality%20show%20wide%20shot%2C%20deep%20blue%20sea%20under%20a%20warm%20orange%20sunset%2C%20distant%20runners%20on%20a%20beach%2C%20fun%20adventurous%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-v004&orientation=landscape',
    tagline: '一路奔跑，一路欢笑',
    synopsis: '明星与素人组成临时战队，走遍山川湖海完成一项项脑力与体力并重的挑战。在名次之外，队员之间从陌生到默契的成长，才是节目最动人的部分。',
    director: '综艺制作中心',
    cast: ['庞一鸣', '田小甜', '江野', '安然'],
    duration: '-',
    episodes: '全 12 期',
    status: '已完结',
    featured: false,
  },
  {
    id: 'v005',
    title: '明星大侦探',
    type: 'variety',
    year: 2024,
    region: '中国大陆',
    genres: ['推理', '真人秀', '悬疑'],
    rating: 8.7,
    heat: 8260,
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20variety%20show%20poster%2C%20elegant%20vintage%20drawing%20room%20with%20candlelight%2C%20deep%20blue%20shadows%20and%20warm%20orange%20glow%2C%20intriguing%20deduction%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v005&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Grand%20vintage%20drawing%20room%20wide%20shot%20for%20a%20mystery%20variety%20show%2C%20deep%20blue%20shadows%20with%20warm%20orange%20candlelight%2C%20antique%20furniture%2C%20intriguing%20deduction%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-v005&orientation=landscape',
    tagline: '真相只有一个',
    synopsis: '六位嘉宾每期扮演不同角色，置身于精心搭建的案件现场。通过搜证、对峙与推理，找出隐藏其中的「凶手」。烧脑的案件设计与密集的笑点让推理变得轻松有趣。',
    director: '推理综艺组',
    cast: ['老徐', '阿May', '江野', '苏念', '程一诺'],
    duration: '-',
    episodes: '全 16 期',
    status: '已完结',
    featured: true,
  },
  {
    id: 'v006',
    title: '向往的生活馆',
    type: 'variety',
    year: 2023,
    region: '中国大陆',
    genres: ['生活', '慢综艺', '治愈'],
    rating: 8.9,
    heat: 8510,
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20slow%20life%20variety%20show%20poster%2C%20a%20warm%20rural%20farmhouse%20courtyard%20with%20lanterns%20and%20a%20shared%20dinner%20table%2C%20deep%20blue%20dusk%20and%20warm%20orange%20light%2C%20peaceful%20healing%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v006&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20farmhouse%20at%20dusk%20wide%20shot%2C%20deep%20blue%20evening%20sky%20with%20warm%20orange%20lantern%20glow%2C%20vegetable%20garden%20and%20wooden%20fence%2C%20cozy%20slow%20life%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mock-banner-v006&orientation=landscape',
    tagline: '把日子过成想要的样子',
    synopsis: '几位常驻嘉宾在乡间小院里种菜、做饭、招待来客。没有剧本与任务，只有日出而作、日落而息的日常。慢下来的时光，反而让每一次相聚都格外珍贵。',
    director: '生活综艺组',
    cast: ['沈知味', '安然', '老周'],
    duration: '-',
    episodes: '全 18 期',
    status: '已完结',
    featured: false,
  },
  {
    id: 'm009',
    title: '深海纪元',
    type: 'movie',
    year: 2026,
    region: '中国大陆',
    genres: ['科幻', '灾难', '冒险'],
    rating: 8.6,
    heat: 8030,
    cover: 'https://readdy.ai/api/search-image?query=Deep%20sea%20sci-fi%20movie%20poster%2C%20a%20submarine%20descending%20into%20a%20dark%20glowing%20trench%2C%20deep%20navy%20water%20with%20warm%20orange%20bioluminescent%20creature%20light%2C%20mysterious%20tense%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-m009&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20wide%20shot%20for%20a%20sci-fi%20disaster%20film%2C%20deep%20navy%20abyss%20with%20warm%20orange%20bioluminescent%20glow%2C%20distant%20submarine%20lights%2C%20cinematic%20underwater%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-m009&orientation=landscape',
    tagline: '海平面之下，另一个世界醒来',
    synopsis: '一场突如其来的海底异动打破了平静，深潜队奉命前往万米海沟调查。在那里，他们发现了从未被记载的生命形态，也触碰到可能改变人类命运的真相。',
    director: '苏景行',
    cast: ['顾星河', '叶清欢', '秦未晚'],
    duration: '138 分钟',
    episodes: '-',
    status: '即将上映',
    featured: false,
  },
  {
    id: 't009',
    title: '雾都档案',
    type: 'tv',
    year: 2024,
    region: '英国',
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 8.4,
    heat: 6180,
    cover: 'https://readdy.ai/api/search-image?query=British%20mystery%20series%20poster%2C%20a%20detective%20on%20a%20foggy%20cobblestone%20street%20with%20a%20gas%20lamp%2C%20deep%20blue%20mist%20with%20warm%20orange%20glow%2C%20vintage%20noir%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-t009&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Foggy%20old%20European%20street%20at%20night%20wide%20shot%2C%20deep%20blue%20mist%20with%20warm%20orange%20gas%20lamp%20glow%2C%20cobblestones%20and%20brick%20buildings%2C%20mystery%20drama%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-t009&orientation=landscape',
    tagline: '卷宗之下，是人心',
    synopsis: '一位固执的老探长在退休前接下最后一桩悬案。随着旧档案被一页页翻起，隐藏在体面外表下的谎言逐渐浮现。真相或许迟到，但从不缺席。',
    director: 'Oliver Grant',
    cast: ['Arthur Boyle', 'Charlotte Reed', 'Nora Vance'],
    duration: '-',
    episodes: '全 8 集',
    status: '已完结',
    featured: false,
  },
  {
    id: 'v007',
    title: '城市漫游记',
    type: 'variety',
    year: 2023,
    region: '中国大陆',
    genres: ['旅行', '人文', '纪实'],
    rating: 8.6,
    heat: 5940,
    cover: 'https://readdy.ai/api/search-image?query=City%20travel%20documentary%20variety%20poster%2C%20a%20traveler%20on%20an%20old%20town%20bridge%20with%20city%20lights%2C%20deep%20blue%20dusk%20with%20warm%20orange%20street%20glow%2C%20curious%20calm%20mood%2C%20cinematic%20key%20art%2C%20no%20text%2C%20detailed&width=600&height=900&seq=mock-cover-v007&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Charming%20old%20town%20canal%20at%20blue%20hour%20wide%20shot%2C%20deep%20blue%20sky%20with%20warm%20orange%20window%20and%20street%20lights%2C%20reflections%20on%20water%2C%20travel%20documentary%20key%20art%2C%20no%20text&width=1600&height=900&seq=mock-banner-v007&orientation=landscape',
    tagline: '慢慢走，慢慢看',
    synopsis: '一位背着相机的旅行者用双脚丈量一座座城市。他不赶景点，只跟随当地人走进菜市场、老巷子与深夜食堂，用镜头记录下城市最真实的呼吸。',
    director: '纪录片工作室',
    cast: ['陆远行'],
    duration: '-',
    episodes: '全 10 期',
    status: '已完结',
    featured: false,
  },
];

export const heroSlides = ['m001', 't001', 'v002', 'm004', 't008'];

export const topicCollections = [
  { id: 'topic-1', title: '硬核科幻宇宙', desc: '从星海到深海，探索未知的浪漫', type: 'movie' as MediaType, count: 68 },
  { id: 'topic-2', title: '口碑悬疑合辑', desc: '反转不断，烧脑一整晚', type: 'tv' as MediaType, count: 45 },
  { id: 'topic-3', title: '治愈系慢综艺', desc: '把生活调成喜欢的频道', type: 'variety' as MediaType, count: 32 },
  { id: 'topic-4', title: '年度高分佳作', desc: '编辑精选，评分 8.5 以上', type: 'movie' as MediaType, count: 51 },
];

export const regionOptions = ['全部', '中国大陆', '中国香港', '美国', '英国', '日本', '韩国'];
export const yearOptions = ['全部', '2026', '2025', '2024', '2023', '2022'];